// Copyright (c) 2017 Deere & Company

import './index.scss';
import * as ClaimSearchHelper from '../../shared/services/claim-search-helper';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import ClaimSearchList from '../../claim-search/components/claim-search-list';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import ClaimsInProgressHeader from './claims-in-progress-header';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import SearchFilters from '../../../shared/state/search-filters';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToExcel} from '../../../shared/services/export-to-excel';
import {getClaimsColumns} from '../../shared/services/claims-excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('claims');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'claims');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.claims.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('claims', this.exportToExcel.selectedExcelLayout.claims.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.claims);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'claims');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('claims', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'claims');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleCreateClaimModalClose() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleStatusChange(event) {

    this.actions.updateClaimStatus(event.target.value);

}

function handleClick(key, pin) {

    this.actions.onCreateClaim(key, pin);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.claims.name, this.exportToExcel.selectedExcelLayout.claims.listId, 'claims');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.claims.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'claims');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

class ClaimsInProgress extends Component {

    componentWillMount() {

        this.props.actions.readClaimTypes();

        // if status is passed in the url, use it otherwise use the one set as default in the state

        const status = typeof this.props.queryParams.status === 'undefined' ? this.props.selectedStatus : this.props.queryParams.status;

        this.props.actions.updateClaimStatus(status);

    }

    componentWillUnmount() {

        this.props.actions.resetClaimsInProgress();
        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.claims];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, ClaimSearchHelper.getFilterOptions(), sortedCollection);

        return (
            <section className='claims-in-progress'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <ClaimsInProgressHeader
                    allowedStatuses={this.props.allowedStatuses}
                    numberOfClaims={this.props.claims.length}
                    onStatusChange={this.props::handleStatusChange}
                    pathName={this.props.pathName}
                    selectedStatus={this.props.selectedStatus}
                />
                <section className='claim-search-results-container'>
                    <RefinableListWidgetWithExportAndLayouts
                        excelLayouts={this.props.exportToExcel.excelLayouts.claims}
                        hasResults={this.props.claims.length > 0}
                        onCreateLayout={this.props::handleCreateExcelLayout}
                        onEditLayout={this.props::handleEditExcelLayout}
                        onExport={() => exportToExcel(`/api/claims?claimStatus=${this.props.selectedStatus}&export=EXCEL&language=${this.props.user.getLocale()}&
                        layout=${encodeURIComponent(this.props.exportToExcel.selectedExcelLayout.claims.name)}&listId=claims`)}
                        onFilterByChange={this.props.actions.updateListFilterBy}
                        onLayoutChange={this.props::handleExcelLayoutChange}
                        onSortByChange={this.props.actions.updateListSortBy}
                        onSortDirectionChange={this.props.actions.updateListSortDirection}
                        searchFilters={this.props.searchFilters}
                        selectedLayout={this.props.exportToExcel.selectedExcelLayout.claims}
                        sortOptions={ClaimSearchHelper.getAllClaimsSortOptions()}
                        type={State}
                    />
                    <ClaimSearchList
                        actions={this.props.actions}
                        busyCounter={this.props.busyCounter}
                        claims={sortedCollection}
                        isEditable={false}
                    />
                </section>
                <CreateClaimModal
                    claimTypes={this.props.createClaimModal.claimTypes}
                    isModalOpen={this.props.createClaimModal.isModalOpen}
                    onClick={this.props::handleClick}
                    onCloseButtonClick={this.props::handleCreateClaimModalClose}
                    selectedPin={this.props.createClaimModal.selectedPin}
                />
                <ExcelLayoutModal
                    excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                    mappingTable={getClaimsColumns().listColumns}
                    onColumnMove={this.props::handleColumnMove}
                    onColumnPush={this.props::handleColumnPush}
                    onColumnRemove={this.props::handleColumnRemove}
                    onLayoutDelete={this.props::handleExcelLayoutDelete}
                    onLayoutNameBlur={this.props::handleLayoutNameBlur}
                    onLayoutNameChange={this.props::handleLayoutNameChange}
                    onModalClose={this.props::handleExcelLayoutModalClose}
                    onSaveLayout={this.props::handleSaveExcelLayout}
                    onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                    onSortByChange={this.props::handleSortByChange}
                    onSortDirectionChange={this.props::handleSortDirectionChange}
                    sortByList={getSortByList(getClaimsColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                />
            </section>
        );

    }

}

ClaimsInProgress.displayName = 'ClaimsInProgress';
ClaimsInProgress.propTypes = {
    actions: PropTypes.object.isRequired,
    allowedStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(ClaimSearchResult)).isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    pathName: PropTypes.string.isRequired,
    queryParams: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    selectedStatus: PropTypes.string.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimsInProgress;



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/components/claims-in-progress.js